module.exports = __webpack_public_path__ + "b97a77302a4174b8d21a57a39acb74e1.png";